import { OrganizationTableItem } from 'types/organizations_table'
import { isActiveProduct } from './formatDayjsDateTime'

export const isProductsOnboarding = (products: OrganizationTableItem[]) => {
  if (!products) return null
  const activeProducts = products
    ?.map(p => {
      return isActiveProduct(p?.startDate, p?.endDate) && !['Ended', 'Cancelled', 'Expired']?.includes(p?.status)
        ? { ...p }
        : null
    })
    ?.filter(Boolean)
  const uniqueDealIds = Array.from?.(new Set(activeProducts?.map(p => p?.deal_uuid)))
  const onboardingProducts = activeProducts
    ?.map(p => {
      return uniqueDealIds?.includes(p?.deal_uuid) ? { ...p, isOnboarding: true } : null
    })
    ?.filter(Boolean)
  return onboardingProducts
}
